export default __webpack_public_path__ + "static/media/intro.ba25c8b4.png";